import { useState } from "react";
import { apiRoute } from "services";
import { dataQueryStatus } from "utils";
import API from "services/lib/api";
import { getErrorMessage } from "utils/helper";
import { fpInstance } from "pages/PublicPages";

const { IDLE, LOADING, SUCCESS } = dataQueryStatus;
export const ResendOTP = ({ userId, setErrorMsg, source, sessionId }) => {
	const [status, setStatus] = useState(IDLE);
	const [timeLeft, setTimeLeft] = useState(null);


	const resendOtp = async () => {
		try {
			setStatus(LOADING);
			setErrorMsg();

			const url = source === fpInstance ? apiRoute.resendPwdOTP(sessionId) : apiRoute.resendOTP(userId);
			const res = await API.get(url);
			if (res.status === 200) {
				setStatus(SUCCESS)
				callTimer()
			}

		} catch (err) {
			setStatus(IDLE)
			setErrorMsg(getErrorMessage(err))

		}
	}

	const timer = (time, update, complete) => {
		const start = new Date().getTime();
		let interval = setInterval(function () {
			let now = time - (new Date().getTime() - start);
			if (now <= 0) {
				clearInterval(interval);
				complete();
			} else update(Math.floor(now / 1000));
		}, 100);
	};

	const callTimer = () => {
		timer(
			61000,
			(timeleft) => {
				let minLeft = Math.floor(timeleft / 60);
				let secsLeft = timeleft % 60;
				if (secsLeft < 10) secsLeft = "0" + secsLeft;
				const time = "0" + minLeft + ":" + secsLeft;
				setTimeLeft(time);
			},
			() => {
				setTimeLeft(null);
				setStatus(IDLE);
				// dispatch(_clearAlert());
			}
		);
	};


	return status === SUCCESS ? (
		<p className="text-dark">
			Resend in <span className="fw-medium">{timeLeft}</span>
		</p>
	) : (
		<p className="text-dark">
			Didn’t recieve OTP via email?{" "}
			<span className="text-primary cursor-pointer" onClick={resendOtp}>
				Resend{status === LOADING ? "ing OTP..." : " OTP"}
			</span>
		</p>
	);
};
